export const adjustImageSize = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    // eslint-disable-next-line no-useless-escape
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        document.querySelectorAll(".jsCalloutImage").forEach(elem => {
            elem.classList.remove("calloutText__backgroundImage--cover");
            elem.classList.add("calloutText__backgroundImage--ie");
        });
    }
};
